import { useEffect } from "react";

import { usePageTitle } from "@/atoms/page-title-atom";
import { LoadingScreen } from "@components/title-slide-view";
import {
  PrettyActiveTab,
  useMMMActiveTab,
} from "@features/mmm/hooks/mmm-url-state";
import { useNorthbeamQuery } from "@hooks/http";
import { type FetchMMMEnabled } from "@north-beam/nb-client-side";
import { MMMClientState } from "@north-beam/nb-common";

import { MMM_ENABLED_QUERY } from "./explore-budgets-v2/explore-budgets-queries";
import { useSelectedCycle } from "./hooks/use-selected-cycle";
import { LandingPage } from "./landing-page";
import { MMMPage } from "./mmm";
import { MmmProvider } from "./mmm-provider";

export default function MMM() {
  const [, setPageTitle] = usePageTitle();
  const { activeTab } = useMMMActiveTab();
  const { selectedCycle } = useSelectedCycle();

  const { data, loading } =
    useNorthbeamQuery<FetchMMMEnabled>(MMM_ENABLED_QUERY);

  useEffect(() => {
    setPageTitle(
      `MMM+ ${
        selectedCycle?.state === MMMClientState.POPULATING_DATA
          ? "Inputting Data"
          : activeTab
          ? PrettyActiveTab[activeTab]
          : ""
      }`,
    );
  }, [activeTab, selectedCycle?.state, setPageTitle]);

  if (loading) {
    return <LoadingScreen />;
  }

  if (!data?.me.mmm.enabled) {
    return <LandingPage />;
  }
  return (
    <MmmProvider>
      <MMMPage />
    </MmmProvider>
  );
}
